import React, { useEffect, useState } from 'react';
import Button from "@mui/material/Button";
import VerifiedIcon from '@mui/icons-material/Verified'
import Dropdown from "react-bootstrap/Dropdown";
import { useLocation } from 'react-router-dom';
import {
    Card, CardContent, Typography, Grid, Chip, Avatar
} from '@mui/material';
import NavBar from '../../structure/NavBar';
import { NavBarTop } from '../../structure/NavBarTop';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { updateTopHeader, updateLoading } from '../../../redux/features/common/commonSlice';
import urls from '../../constants/apiurl';
import ApiCaller from '../../constants/ApiCaller';
import { showDangerToast, showToast } from '../../constants/toaster';
import Utils from '../../constants/Utils';
import { FullImageView } from '../../custom/FullImageView';
import Image from '../../custom/Image';
const statusMenu = [{
    label: 'Submitted',
    value: 'SUBMITTED'
},
{
    label: 'Re-Submitted',
    value: 'RESUBMITTED'
}, {
    label: 'Approve',
    value: 'APPROVE'
}, {
    label: 'Reject',
    value: 'REJECT'
}

]
export const ViewAgentsDetails = () => {
    const location = useLocation();
    const [statusDropdownText, setStatusDropdownText] = useState({ label: 'Submitted', value: 'SUBMITTED' });
    const [imageUrl, setImageUrl] = useState(false)
    const [displayAddress, setDisplayAddress] = useState('-')
    const [fullSizePreview, setFullSizePreview] = useState(false)
    const { formatDate, getAddressFromLatLng } = Utils();
    const { id } = useParams()
    const dispatch = useDispatch()
    const userData = useSelector(state => state?.userData)
    const [merchantDetailsData, setMerchantDetailsData] = useState({})
    const [userDetailsData, setUserDetailsData] = useState({})
    const hiddenData = location.state?.hiddenData;

    useEffect(() => {
        dispatch(updateTopHeader('Agent Details'))
        if (id) {
            console.log(hiddenData)
            if (hiddenData?.userId) {
                getUserDetails(hiddenData?.userId)
                if (hiddenData?.statusType) {
                    if (hiddenData?.statusType === "SUBMITTED") {
                        setStatusDropdownText({
                            label: 'Submitted',
                            value: 'SUBMITTED'
                        })
                    } else if (hiddenData?.statusType === "RESUBMITTED") {
                        setStatusDropdownText({
                            label: 'Re-Submitted',
                            value: 'RESUBMITTED'
                        })
                    } else if (hiddenData?.statusType === "APPROVE") {
                        setStatusDropdownText({
                            label: 'Approve',
                            value: 'APPROVE'
                        })
                    } else if (hiddenData?.statusType === "REJECT") {
                        setStatusDropdownText({
                            label: 'Reject',
                            value: 'REJECT'
                        })
                    }
                }
            }
        } else {
            navigator('/agents-manager')
        }
    }, [id])


    const handleChangeStatus = async () => {
        try {
            dispatch(updateLoading(true))
            let postJson = {
                agentStatus: statusDropdownText?.value,
                id: id
            }
            let path = urls.updateAgentStatus
            let res = await ApiCaller.put(postJson, path, userData?.access_token)
            const response = await res.response.json()
            if (response.status == 200) {
                dispatch(updateLoading(false))
                // getMerchantBusinessDetails(response?.data)
                showToast(response.message)
            } else {
                dispatch(updateLoading(false))
                showDangerToast(response.message)
            }
        } catch (error) {
            dispatch(updateLoading(false))
            console.error(error)
            showDangerToast(error.message)
        }
    }
    const getUserDetails = async (userId) => {
        try {
            dispatch(updateLoading(true))
            let path = urls.userDetails + '/' + userId
            let res = await ApiCaller.get({}, path, userData?.access_token)
            const response = await res.response.json()
            if (response.status == 200) {
                dispatch(updateLoading(false))
                setUserDetailsData(response?.data)
            } else {
                dispatch(updateLoading(false))
                showDangerToast(response.message)
            }
        } catch (error) {
            dispatch(updateLoading(false))
            console.error(error)
            showDangerToast(error.message)
        }
    }

    const redirectToGoogleMaps = (lat, lng) => {
        const url = `https://www.google.com/maps?q=${lat},${lng}`;
        window.open(url, '_blank');
    };


    return (
        <>
            <>
                <NavBar />
                <div className="main-content">
                    <NavBarTop />
                    <div className="header">
                        <div className="logo">
                            <div className="header bg-gradient-primary pb-8 ">
                            </div>
                        </div>
                    </div>
                    <div>
                        <div>
                            <Dropdown>
                                <Dropdown.Toggle
                                    variant="success"
                                    style={{
                                        backgroundColor: "white",
                                        color: "black",
                                        border: "1px solid #cad1d7",
                                        boxShadow: "none",
                                        transform: "none",
                                    }}
                                    id="dropdown-basic"
                                >
                                    {statusDropdownText?.label}
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    {statusMenu?.map((menuItem) => {
                                        return <Dropdown.Item
                                            onClick={() => setStatusDropdownText(menuItem)}
                                        >
                                            {menuItem?.label}
                                        </Dropdown.Item>
                                    })}
                                </Dropdown.Menu>
                            </Dropdown>

                            <Button
                                variant="contained"
                                className="custom-filter-btn ml-3"
                                onClick={() => handleChangeStatus()}
                            >
                                Update
                            </Button>
                        </div>
                    </div>
                    <div style={{ padding: '1rem' }}>
                        <Card sx={{ mb: 2 }}>
                            <CardContent>
                                <Typography variant="h6">Agent Overview</Typography>
                                <div className='row'>
                                    <div className='col-md-8'>
                                        <div className='card'>
                                            <div className='card-body'>
                                                <div className='row'>
                                                    <div className='col-md-2' style={{ textAlign: 'left' }}>
                                                        <label
                                                            htmlFor='example-text-input'
                                                            className='form-control-label'
                                                        >
                                                            Username
                                                        </label>
                                                        <p>{userDetailsData?.userName}</p>
                                                    </div>
                                                    <div className='col-md-2' style={{ textAlign: 'left' }}>
                                                        <label
                                                            htmlFor='example-text-input'
                                                            className='form-control-label'
                                                        >
                                                            USER ID
                                                        </label>
                                                        <p>{userDetailsData?.chatUserId}</p>
                                                    </div>
                                                    <div className='col-md-2' style={{ textAlign: 'left' }}>
                                                        <label
                                                            htmlFor='example-text-input'
                                                            className='form-control-label'
                                                        >
                                                            Full Name
                                                        </label>
                                                        <p>{userDetailsData?.fullName}</p>
                                                    </div>
                                                    <div className='col-md-3' style={{ textAlign: 'left' }}>
                                                        <label
                                                            htmlFor='example-text-input'
                                                            className='form-control-label'
                                                        >
                                                            Email
                                                        </label>
                                                        <p>{userDetailsData?.email}</p>
                                                    </div>
                                                    <div className='col-md-3' style={{ textAlign: 'left' }}>
                                                        <label
                                                            htmlFor='example-text-input'
                                                            className='form-control-label'
                                                        >
                                                            Mobile
                                                        </label>
                                                        <p>
                                                            {userDetailsData?.ext} {userDetailsData?.contactNumber}
                                                        </p>
                                                    </div>
                                                    <div className='col-md-2' style={{ textAlign: 'left' }}>
                                                        <label
                                                            htmlFor='example-text-input'
                                                            className='form-control-label'
                                                        >
                                                            Gender
                                                        </label>
                                                        <p>{userDetailsData?.gender}</p>
                                                    </div>
                                                    <div className='col-md-2' style={{ textAlign: 'left' }}>
                                                        <label
                                                            htmlFor='example-text-input'
                                                            className='form-control-label'
                                                        >
                                                            Date Of Birth
                                                        </label>
                                                        <p>{userDetailsData?.dob}</p>
                                                    </div>
                                                    <div className='col-md-2' style={{ textAlign: 'left' }}>
                                                        <label
                                                            htmlFor='example-text-input'
                                                            className='form-control-label'
                                                        >
                                                            Date Of Registration
                                                        </label>
                                                        <p>{formatDate(userDetailsData?.createdAt)}</p>
                                                    </div>
                                                    <div className='col-md-2' style={{ textAlign: 'left' }}>
                                                        <label
                                                            htmlFor='example-text-input'
                                                            className='form-control-label'
                                                        >
                                                            Exclusive Enable
                                                        </label>
                                                        <p>
                                                            {userDetailsData?.exclusiveEnable ? (
                                                                <span className='label label-default'>Enabled</span>
                                                            ) : (
                                                                <span className='label label-default'>Disabled</span>
                                                            )}
                                                        </p>
                                                    </div>
                                                    <div className='col-md-2' style={{ textAlign: 'left' }}>
                                                        <label
                                                            htmlFor='example-text-input'
                                                            className='form-control-label'
                                                        >
                                                            Account Type
                                                        </label>
                                                        <p>{userDetailsData?.accountType}</p>
                                                    </div>
                                                    <div className='col-md-2' style={{ textAlign: 'left' }}>
                                                        <label
                                                            htmlFor='example-text-input'
                                                            className='form-control-label'
                                                        >
                                                            Register Via
                                                        </label>
                                                        <p>{userDetailsData?.signInType}</p>
                                                    </div>
                                                    <div className='col-md-2' style={{ textAlign: 'left' }}>
                                                        <label
                                                            htmlFor='example-text-input'
                                                            className='form-control-label'
                                                        >
                                                            Total Chips:
                                                        </label>
                                                        <p>{userDetailsData?.totalChipsBalance}</p>
                                                    </div>
                                                    <div className='col-md-10' style={{ textAlign: 'left' }}>
                                                        <label
                                                            htmlFor='example-text-input'
                                                            className='form-control-label'
                                                        >
                                                            Category:
                                                        </label>
                                                        <p>{userDetailsData?.userPreferredTags?.join(",")}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-md-4'>
                                        <div className='card card-profile'>
                                            <div className='row justify-content-center'>
                                                <div className='col-4 col-lg-4 order-lg-2'>
                                                    <div className='mt-n4 mt-lg-n6 mb-4 mb-lg-0'>
                                                        <a href='javascript:;'>
                                                            <img
                                                                src={userDetailsData?.profilePic}
                                                                onClick={() => {
                                                                    setFullSizePreview(!fullSizePreview)
                                                                    setImageUrl(userDetailsData?.profilePic)
                                                                }}
                                                                className='rounded-circle img-fluid border border-2 border-white'
                                                            />
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='card-header text-center border-0 pt-0 pt-lg-2 pb-4 pb-lg-3'>
                                                {userDetailsData?.isBadged ? <VerifiedIcon /> : <></>}
                                            </div>
                                            <div className='card-body pt-0'>
                                                <div className='row'>
                                                    <div className='col'>
                                                        <div
                                                            className='d-flex justify-content-center'
                                                            style={{ fontWeight: 'bold' }}
                                                        >
                                                            <div className='d-grid text-center'>
                                                                <span className='text-lg font-weight-bolder'>
                                                                    {userDetailsData?.totalFollowers}
                                                                </span>
                                                                <span className='text-sm opacity-8 ml-2'>
                                                                    Followers
                                                                </span>
                                                            </div>
                                                            <div className='d-grid text-center mx-4'>
                                                                <span className='text-lg font-weight-bolder'>
                                                                    {userDetailsData?.totalFollowing}
                                                                </span>
                                                                <span className='text-sm opacity-8 ml-2'>
                                                                    Following
                                                                </span>
                                                            </div>
                                                            <div className='d-grid text-center mr-4'>
                                                                <span className='text-lg font-weight-bolder'>
                                                                    {userDetailsData?.totalVideos}
                                                                </span>
                                                                <span className='text-sm opacity-8 ml-2'>Videos</span>
                                                            </div>
                                                            <div className='d-grid text-center'>
                                                                <span className='text-lg font-weight-bolder'>
                                                                    {userDetailsData?.totalLikes}
                                                                </span>
                                                                <span className='text-sm opacity-8 ml-2'>Likes</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='text-center mt-4'>
                                                    <h3>
                                                        {userDetailsData?.fullName}
                                                        <span className='font-weight-light'>, 35</span>
                                                    </h3>
                                                    <div className='h4 font-weight-bold'>
                                                        <i className='ni location_pin mr-2' />
                                                        {userDetailsData?.userName}
                                                    </div>
                                                    <div>
                                                        <i className='ni education_hat mr-2' />
                                                        {userDetailsData?.bio}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </CardContent>
                        </Card>
                        {hiddenData ? <Card key={1} sx={{ mb: 3 }}>
                            <CardContent>
                                <Typography variant="h6">Kyc Details</Typography>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} md={4} className='text-left'>
                                        <Typography><strong>Live Selfie:</strong>
                                            {hiddenData?.liveSelfie ? <div style={{ cursor: 'pointer' }} onClick={() => {
                                                setFullSizePreview(!fullSizePreview)
                                                setImageUrl(hiddenData?.liveSelfie)
                                            }}> <Image
                                                    image={{
                                                        id: 1,
                                                        src: hiddenData?.liveSelfie || "https://www.shutterstock.com/image-vector/default-ui-image-placeholder-wireframes-600nw-1037719192.jpg"
                                                    }}
                                                    width='150px'
                                                    height='auto'
                                                /> </div> : 'No Document Provided'}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12} md={4} className='text-left'>
                                        <Typography><strong>Document ID:</strong>
                                            {hiddenData?.documentUrl ? <div style={{ cursor: 'pointer' }} onClick={() => {
                                                setFullSizePreview(!fullSizePreview)
                                                setImageUrl(hiddenData?.documentUrl)
                                            }}><Image
                                                    image={{
                                                        id: 1,
                                                        src: hiddenData?.documentUrl || "https://www.shutterstock.com/image-vector/default-ui-image-placeholder-wireframes-600nw-1037719192.jpg"
                                                    }}
                                                    width='150px'
                                                    height='auto
'
                                                /></div> : 'No Document Provided'}

                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12} md={4} className='text-left'>
                                        <Typography><strong>ID Number: {hiddenData?.documentId}</strong>
                                        </Typography>
                                        <Typography><strong>Agent Code: {hiddenData?.code}</strong>
                                        </Typography>
                                        <Typography><strong>Location: <span style={{ fontSize: '15px', fontWeight: '500px', color: 'blue', cursor: 'pointer' }} onClick={() => redirectToGoogleMaps(hiddenData?.lat, hiddenData?.lng)}>
                                            Open in Google Maps
                                        </span></strong>
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card> : <></>}

                    </div>
                    <FullImageView
                        src={imageUrl}
                        show={fullSizePreview}
                        onHide={() => setFullSizePreview(false)}
                    />
                </div>
            </>
        </>
    );

}